var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPerms(_vm.perms))?_c('el-button',{attrs:{"size":_vm.$size,"type":_vm.type,"icon":_vm.icon,"plain":_vm.plain,"loading":_vm.loading,"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }